<template>
  <div class="apple-footer">
    <!-- Main Footer Content -->
    <div class="footer-container">
      <div class="footer-content">
        <!-- Company Section -->
        <div class="footer-section company-section">
          <div class="footer-brand-wrapper">
  <img :src="logo" alt="PA Tours & Travels Logo" class="footer-logo" />
  <h3 class="footer-brand">PA Tours & Travels</h3>
</div>
          
          <p class="company-description">
            Your trusted partner for unforgettable travel experiences across Kerala and beyond. 
            Creating memories that last a lifetime.
          </p>

          <!-- Social Links -->
          <div class="social-links">
            <a 
              href="https://www.instagram.com/p.a.travels?igsh=Y2ozdTNxZmtjZXRl" 
              target="_blank"
              class="social-link"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" class="social-icon">
                <path fill="currentColor" d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />
              </svg>
            </a>
            <a 
              href="https://www.facebook.com/patravels.patravels" 
              target="_blank"
              class="social-link"
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" class="social-icon">
                <path fill="currentColor" d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z" />
              </svg>
            </a>
           <a 
            href="https://wa.me/919400623107" 
              target="_blank"
              class="social-link"
              aria-label="WhatsApp"
              >
              <svg viewBox="0 0 24 24" class="social-icon">
                <path fill="currentColor" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z" />
              </svg>
            </a>
            <a 
              href="https://twitter.com/" 
              target="_blank"
              class="social-link"
              aria-label="Twitter"
            >
              <svg viewBox="0 0 24 24" class="social-icon">
                <path fill="currentColor" d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.70,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />
              </svg>
            </a>
          </div>
        </div>

        <!-- Destinations -->
        <div class="footer-section">
          <h4 class="footer-heading">Quick Links</h4>
          <ul class="footer-links">
            <li v-for="(link, index) in destinationLinks" :key="index">
              <router-link :to="link.path" class="footer-link">
                {{ link.label }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Services -->
        <div class="footer-section">
          <h4 class="footer-heading">Services</h4>
          <ul class="footer-links">
            <li v-for="(link, index) in serviceLinks" :key="index">
              <router-link :to="link.path" class="footer-link">
                {{ link.label }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact Info -->
        <div class="footer-section contact-section">
          <h4 class="footer-heading">Contact Us</h4>
          <div class="contact-items">
            <div class="contact-item">
              <p class="contact-text">
                PA Tours And Travels<br>
                Chalakudy, Kerala<br>
                India
              </p>
            </div>
            <div class="contact-item">
              <a href="tel:+919876543210" class="contact-link">+91 94006 23107</a>
            </div>
            <div class="contact-item">
              <a href="mailto:info@travelco.com" class="contact-link">patravelschalakudy@gmail.com</a>
            </div>
            
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="footer-divider"></div>

      <!-- Bottom Bar -->
      <div class="footer-bottom">
        <div class="footer-bottom-left">
          <p class="copyright">© 2026 PA Tours & Travels . All rights reserved.</p>
        </div>
        
        <div class="footer-bottom-center">
          <router-link to="/privacypolicy" class="legal-link">Privacy Policy</router-link>
          <span class="separator">•</span>
          <router-link to="/termsandconditions" class="legal-link">Terms of Service</router-link>
          <span class="separator">•</span>
          <router-link to="/cancellationpolicy" class="legal-link">Cancellation Policy</router-link>
        </div>
        
        <div class="footer-bottom-right">
          <p class="developer-credit">
            Designed & Developed by 
            <a href="https://cybercraftinnovations.com/" target="_blank" class="developer-link">
              Cyber Craft Innovations
            </a>
          </p>
        </div>
      </div>
    </div>

    <!-- Scroll to Top Button -->
    <transition name="fade">
      <button v-if="showScrollTop" @click="scrollToTop" class="scroll-top-btn" aria-label="Scroll to top">
        <svg viewBox="0 0 24 24" class="scroll-icon">
          <path fill="currentColor" d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
        </svg>
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TravelFooter',
  data() {
    return {
      logo: require("../assets/img/logo33.png"),
      showScrollTop: false,
      destinationLinks: [
        { label: 'About Us', path: '/AboutUs' },
        { label: 'Our Services', path: '/ourServices' },
        { label: 'Popular Destinations', path: '/popularDestinations' },
        { label: 'What Our Customers Say', path: '/reviewPage' },
        
      ],
      serviceLinks: [
        { label: 'Tour Packages', path: '/TourPackages' },
        { label: 'Hotel Booking', path: '/HotelDetails' },
        { label: 'Cab Services', path: '/Cabs' },
        { label: 'Flight Booking', path: '/FlightDetails' },
        { label: 'School/College Tours', path: '/OurTourPackages' },
      ]
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showScrollTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.apple-footer {
  background: #f5f5f7;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  padding: 60px 0 0;
  border-top: 1px solid #d2d2d7;
}

/* Container */
.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

/* Footer Content Grid */
.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 60px;
  padding-bottom: 40px;
}

/* Company Section */
.company-section {
  max-width: 350px;
}


.footer-brand-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.footer-logo {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.company-description {
  font-size: 13px;
  line-height: 1.6;
  color: #6e6e73;
  margin: 0 0 24px 0;
}

/* Social Links */
.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 50%;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-link:hover {
  background: rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.social-icon {
  width: 18px;
  height: 18px;
  color: #1d1d1f;
  transition: color 0.3s ease;
}

.social-link:hover .social-icon {
  color: #000;
}

/* Footer Sections */
.footer-section {
  min-width: 0;
}

.footer-heading {
  font-size: 13px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 16px 0;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

/* Links */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-link {
  color: #6e6e73;
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
  transition: color 0.3s ease;
  display: inline-block;
}

.footer-link:hover {
  color: #1d1d1f;
}

/* Contact Section */
.contact-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  margin: 0;
}

.contact-text {
  font-size: 12px;
  line-height: 1.6;
  color: #6e6e73;
  margin: 0;
}

.contact-hours {
  margin-top: 4px;
  font-style: italic;
}

.contact-link {
  color: #6e6e73;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s ease;
  display: block;
  margin-bottom: 4px;
}

.contact-link:hover {
  color: #1d1d1f;
}

/* Divider */
.footer-divider {
  height: 1px;
  background: #d2d2d7;
  margin: 0 0 20px 0;
}

/* Bottom Bar */
.footer-bottom {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 20px;
  padding: 20px 0 30px;
}

.footer-bottom-left {
  text-align: left;
}

.footer-bottom-center {
  display: flex;
  gap: 12px;
  align-items: center;
}

.footer-bottom-right {
  text-align: right;
}

.copyright {
  font-size: 12px;
  color: #6e6e73;
  margin: 0;
  line-height: 1.5;
}

.developer-credit {
  font-size: 13px;
  color: #1d1d1f;
  margin: 0;
  line-height: 1.5;
  font-weight: 500;
}

.separator {
  color: #d2d2d7;
  font-size: 11px;
}

.legal-link {
  color: #6e6e73;
  text-decoration: none;
  font-size: 11px;
  font-weight: 400;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.legal-link:hover {
  color: #1d1d1f;
}

.developer-link {
  font-size: 14px;
  color: #01ccc5;
  text-decoration: italic;
  font-weight: 600;
  transition: opacity 0.3s ease;
  /* border-bottom: 1px solid #000000; */
}

.developer-link:hover {
  opacity: 0.9;
}

/* Scroll to Top Button */
.scroll-top-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 44px;
  height: 44px;
  background: #1d1d1f;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.scroll-top-btn:hover {
  background: #000000;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.scroll-icon {
  width: 20px;
  height: 20px;
  color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(10px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  .company-section {
    grid-column: 1 / -1;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .footer-container {
    padding: 0 24px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .footer-bottom {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 16px;
  }

  .footer-bottom-left,
  .footer-bottom-right {
    text-align: center;
  }

  .footer-bottom-center {
    justify-content: center;
    flex-wrap: wrap;
  }

  .developer-credit {
    font-size: 12px;
  }

  .scroll-top-btn {
    bottom: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
  }

  .scroll-icon {
    width: 18px;
    height: 18px;
  }
}

@media (max-width: 480px) {
  .apple-footer {
    padding: 40px 0 0;
  }

  .footer-container {
    padding: 0 16px;
  }

  .footer-content {
    gap: 24px;
  }

 

  .company-description {
    font-size: 12px;
  }

  .social-links {
    gap: 8px;
  }

  .social-link {
    width: 32px;
    height: 32px;
  }

  .social-icon {
    width: 16px;
    height: 16px;
  }

  .footer-heading {
    font-size: 12px;
  }

  .footer-link,
  .contact-text,
  .contact-link {
    font-size: 11px;
  }

  .footer-bottom {
    gap: 12px;
    padding: 16px 0 24px;
  }

  .footer-bottom-center {
    flex-direction: column;
    gap: 8px;
  }

  .separator {
    display: none;
  }

  .copyright,
  .developer-credit,
  .legal-link {
    font-size: 10px;
  }

  .scroll-top-btn {
    bottom: 16px;
    right: 16px;
  }
}

/* Focus Styles for Accessibility */
.footer-link:focus-visible,
.social-link:focus-visible,
.contact-link:focus-visible,
.legal-link:focus-visible,
.developer-link:focus-visible,
.scroll-top-btn:focus-visible {
  outline: 2px solid #1d1d1f;
  outline-offset: 2px;
}

/* Selection */
::selection {
  background: rgba(0, 0, 0, 0.1);
  color: #1d1d1f;
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
